import { Component, type ErrorInfo, type ReactNode } from "react";
import { trackAnalyticsEvent } from "../services/analytics/analyticsClient";
import { sanitizeErrorForAnalytics } from "../services/analytics/analyticsRedaction";

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  failed: boolean;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { failed: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { failed: true };
  }

  componentDidCatch(error: Error, _info: ErrorInfo): void {
    trackAnalyticsEvent("runtime_error", sanitizeErrorForAnalytics(error, "REACT_RUNTIME_ERROR"), {
      priority: "critical",
      flush: true
    });
  }

  render(): ReactNode {
    if (this.state.failed) {
      return (
        <main className="app-shell">
          <section className="screen screen--center">
            <h1>MoveInReport</h1>
            <div className="notice notice--error">Something went wrong. Refresh this page and your local draft should still be here.</div>
          </section>
        </main>
      );
    }

    return this.props.children;
  }
}
